
















import { Vue, Component } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import userStore from '@/modules/auth/auth.store'
import UserAvatar from '@/modules/shared/components/UserAvatar'
import ServerError from '@/utils/server_error'
import { ResponseStatus, MemberAPI } from '@/api/member'

@Component({
  components: {
    UserAvatar
  }
})
export default class AccountSidebar extends Vue {
  userModule = getModule(userStore, this.$store)
  loading: boolean = false

  get nickname() {
    return this.userModule.nickname
  }

  get userId() {
    return this.userModule.userId
  }

  get authToken() {
    return this.userModule.authToken
  }

  toProfile() {
    if (this.$route.params.memberId === this.userId) {
      return
    }
    this.$router.push({
      name: 'MemberHome',
      params: {
        memberId: this.userId
      }
    })
  }
}
